/* This example requires Tailwind CSS v2.0+ */
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeaderBrandedWithBackgroundImageData on StrapiComponentHeaderBrandedWithBackgroundImage {
    title
    topic
    description
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function BrandedWithBackgroundImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="relative bg-background-primary-dark">
      {data.image && (
        <div className="absolute inset-0">
          <MediaWrapper media={data.image} divClassName="w-full h-full" />
          {/*<div className="absolute inset-0 bg-indigo-800 mix-blend-multiply" aria-hidden="true" />*/}
        </div>
      )}
      <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        {data.topic && (
          <h3 className="text-3xl tracking-tight text-text-white md:text-4xl">
            <MarkdownWrapper text={data.topic} />
          </h3>
        )}
        {data.title && (
          <h1 className="text-4xl font-extrabold tracking-tight text-text-white sm:text-5xl lg:text-6xl">
            <MarkdownWrapper text={data.title} />
          </h1>
        )}
        {data.description && (
          <MarkdownWrapper
            text={data.description}
            markdownClassName="mt-6 text-xl text-text-primary-light max-w-3xl"
            replaceParagraph={false}
          />
        )}
      </div>
    </div>
  );
}

BrandedWithBackgroundImage.propTypes = {
  data: PropTypes.object,
};

export default BrandedWithBackgroundImage;
